import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { unSnake } from 'utils/strings';
import { Plan } from './styled';
export var getInsurancePlanOptionValue = function (plans, type) {
    var _a;
    var plan = plans === null || plans === void 0 ? void 0 : plans.find(function (plan) { var _a; return ((_a = plan === null || plan === void 0 ? void 0 : plan.category) === null || _a === void 0 ? void 0 : _a.code) === type; });
    return {
        value: (plan === null || plan === void 0 ? void 0 : plan.id) || null,
        disabled: !plan,
        label: plan ? (_jsxs(_Fragment, { children: [((_a = plan.category) === null || _a === void 0 ? void 0 : _a.code) && "".concat(unSnake(plan.category.code), " "), plan.display_name && (_jsx(Plan, { type: "normal", children: "(".concat(plan.display_name, ")") }))] })) : (_jsx(Plan, { type: "warning", children: "(Unknown)" }))
    };
};
export var calculateTotalPrice = function (values) {
    var _a = values || {}, _b = _a.cost_coinsurance, cost_coinsurance = _b === void 0 ? 0 : _b, _c = _a.cost_copay, cost_copay = _c === void 0 ? 0 : _c, _d = _a.cost_deductible, cost_deductible = _d === void 0 ? 0 : _d;
    return cost_deductible + cost_copay + cost_coinsurance;
};
